import { filterOptions } from 'utils/methods/helpers';
import { LIST_WIDTH } from 'utils/constants/listview';

export const VISITOR_COLUMNS = {
  PASS_ID: {
    headerName: 'Pass ID',
    field: 'passName',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  TYPE: {
    headerName: 'Visitor Type',
    field: 'type',
    width: LIST_WIDTH.default,
  },
  FIRST_NAME: {
    headerName: 'First Name',
    field: 'firstName',
    width: LIST_WIDTH.default,
  },
  LAST_NAME: {
    headerName: 'Last Name',
    field: 'lastName',
    width: LIST_WIDTH.default,
  },
  COMPANY: {
    headerName: 'Company Name',
    field: 'visitorCompany',
    width: LIST_WIDTH.OBJECT_NAME,
  },
  VEHICLE_REGISTRATION: {
    headerName: 'Vehicle Registration',
    field: 'vehicleRegistration',
    width: LIST_WIDTH.HUMAN_READABLE_ID,
  },
  ACCESS_TIME: {
    headerName: 'Sign in time',
    field: 'accessTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  SIGNED_IN_BY: {
    headerName: 'Signed in by',
    field: 'signedInBy',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  EGRESS_TIME: {
    headerName: 'Sign out time',
    field: 'egressTime',
    width: LIST_WIDTH.TIME_DATE,
  },
  SIGNED_OUT_BY: {
    headerName: 'Signed out by',
    field: 'signedOutBy',
    width: LIST_WIDTH.HUMAN_NAME,
  },
  SITE_NAME: {
    headerName: 'Site Name',
    field: 'siteName',
    width: LIST_WIDTH.STATUS,
  },
};

export const defaultColumns = [
  //VISITOR_COLUMNS.PASS_ID,
  VISITOR_COLUMNS.TYPE,
  VISITOR_COLUMNS.FIRST_NAME,
  VISITOR_COLUMNS.LAST_NAME,
  VISITOR_COLUMNS.COMPANY,
  VISITOR_COLUMNS.VEHICLE_REGISTRATION,
  VISITOR_COLUMNS.ACCESS_TIME,
  VISITOR_COLUMNS.EGRESS_TIME,
];

const columnWithSite = [VISITOR_COLUMNS.SITE_NAME, ...defaultColumns];

const reportingViewColumns = [...columnWithSite, VISITOR_COLUMNS.SIGNED_OUT_BY];

export const columnView = currentPage => {
  const views = {
    operational: columnWithSite,
    managerial: defaultColumns,
    reporting: reportingViewColumns,
  };
  return views[currentPage] || defaultColumns;
};

export const filters = ({ bizClients, sites, currentPage, filterValues }) => {
  const defaultFilters = [
    {
      label: 'Business Client',
      field: 'businessClientId',
      type: 'select',
      options: bizClients.map(item => ({
        id: item.id,
        name: item.name,
      })),
      size: 'large',
    },
    {
      label: 'Site',
      field: 'siteId',
      type: 'select',
      options: filterOptions({
        options: sites,
        filterKey: 'businessClientId',
        filterValue: filterValues.businessClientId,
      }),
    },
    // {
    //   label: 'type',
    //   field: 'type',
    //   type: 'select',
    //   options: Object.entries(visitorType).map(([key, value]) => ({
    //     id: key,
    //     name: value,
    //   })),
    // },
  ];

  switch (currentPage) {
    case 'operational':
      return defaultFilters;
    case 'reporting':
      return [
        ...defaultFilters,
        {
          label: 'dateFrom',
          field: 'fromDate',
          type: 'date-picker',
        },
        {
          label: 'dateTo',
          field: 'toDate',
          type: 'date-picker',
        },
      ];
    default:
      return defaultFilters;
  }
};
